import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";

interface ErrorResponse {
    error: boolean;
    mensaje: string;
    codigo: number;
    datos: {[key: string]: string} | null;
}

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.handleResponse(event.body);
        }
      }),
    );
  }

  private handleResponse(responseBody: any): void {
    if (!responseBody) return;

    if (this.isErrorResponse(responseBody)) {
      this.processError(responseBody);
    }
  }

  private isErrorResponse(body: any): boolean {
    return !!(body.error === true && body.codigo && body.mensaje);
  }

  private processError(responseBody: ErrorResponse): void {
    const mensaje = responseBody.mensaje || 'Ha ocurrido un error';
    alert(mensaje);
    if (responseBody.datos && responseBody.datos["UrlRetorno"]) {
      this.handleRedirection(
        responseBody.datos["UrlRetorno"], 
        responseBody.codigo, 
        responseBody.datos["DescError"]
      );
    } else {
        history.back();
    }
  }

  private handleRedirection(urlRetorno: string, codigo: number, descError: string): void {
    if (!urlRetorno) return;
    window.location.href = `${urlRetorno}2&coderror=${codigo}&desc=${descError}`;
  }
}
